import { router } from "expo-router";
import { Pressable, ScrollView, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { CounterCard } from "~/features/counters/CounterCard";
import { Icon } from "~/components/ui/Icon";
import { RuleLine } from "~/components/ui/RuleLine";
import { BodyText, CaptionText, Heading1 } from "~/components/ui/Text";
import { useAuth } from "~/hooks/useAuth";
import { useCounters } from "~/state/counters";
import { spacing, useTheme } from "~/styles/theme";

export default function HomeScreen() {
  const { colors } = useTheme();
  const { counters, loading } = useCounters();
  const { user, configured } = useAuth();

  return (
    <SafeAreaView
      style={{ flex: 1, backgroundColor: colors.background }}
      edges={["top", "left", "right"]}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingHorizontal: spacing.lg,
          paddingTop: spacing.sm,
          paddingBottom: spacing.md,
        }}
      >
        <Heading1 style={{ letterSpacing: -1 }}>DURANCE</Heading1>
        <View style={{ flexDirection: "row", gap: spacing.lg }}>
          <Pressable
            onPress={() => router.push("/account")}
            hitSlop={12}
            accessibilityLabel="Account"
          >
            <Icon name={user ? "user-check" : "user"} />
          </Pressable>
          <Pressable
            onPress={() => router.push("/counter/new")}
            hitSlop={12}
            accessibilityLabel="Add counter"
          >
            <Icon name="plus" />
          </Pressable>
        </View>
      </View>
      <RuleLine strong />

      {!user && configured ? (
        <View
          style={{
            paddingHorizontal: spacing.lg,
            paddingVertical: spacing.sm,
          }}
        >
          <CaptionText color={colors.muted}>
            Tracking locally on this device. Sign in to sync across devices.
          </CaptionText>
        </View>
      ) : null}

      {loading ? (
        <View
          style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        >
          <CaptionText color={colors.muted}>Loading…</CaptionText>
        </View>
      ) : counters.length === 0 ? (
        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            paddingHorizontal: spacing.xxl,
            gap: spacing.sm,
          }}
        >
          <BodyText weight="semibold" align="center">
            Nothing tracked yet
          </BodyText>
          <CaptionText color={colors.muted} align="center">
            Add a date to count days since or count down to.
          </CaptionText>
        </View>
      ) : (
        <ScrollView
          contentContainerStyle={{
            flexDirection: "row",
            flexWrap: "wrap",
            borderTopWidth: 1,
            borderLeftWidth: 1,
            borderColor: colors.rule,
            margin: spacing.lg,
          }}
        >
          {counters.map((counter) => (
            <CounterCard
              key={counter.id}
              counter={counter}
              onPress={() => router.push(`/counter/${counter.id}`)}
            />
          ))}
        </ScrollView>
      )}
    </SafeAreaView>
  );
}
